import { useState } from "react";
import { toast } from "react-hot-toast";

import { createAxiosInstance } from "api/axiosConfig";
import { PATIENT_FAMILY_MEMBER } from "api/Service";
import { Button } from "components/ui";
import { DialogFooter } from "components/ui/Dialog/DialogFooter";
import { PatientAutocomplete } from "components/ui/PatientAutocomplete/PatientAutocomplete";
import { Select } from "components/ui/Select/Select";

import { RELATIONSHIP_OPTIONS } from "./constants";
import styles from "./PatientFamilySearch.module.css";

const PatientFamilySearch = ({
  currentPatientId,
  closeModal,
  refetchRelationships,
  initialPatientRelationship,
}) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  const [selectedPatient, setSelectedPatient] = useState(
    initialPatientRelationship?.patientId
      ? {
          id: initialPatientRelationship.patientId,
          title: initialPatientRelationship.patientname ?? "",
        }
      : null
  );
  const [relationship, setRelationship] = useState(
    initialPatientRelationship?.familyRelationType ?? ""
  );
  const [isSaving, setIsSaving] = useState(false);

  const isEditing = !!initialPatientRelationship?.id;

  const handleSave = async () => {
    if (!selectedPatient || !relationship) {
      toast.error("Please select a patient and a relationship");
      return;
    }
    if (selectedPatient.id === currentPatientId) {
      toast.error("You cannot create a relationship with the same patient");
      return;
    }

    setIsSaving(true);
    try {
      const axiosInstance = createAxiosInstance();
      await axiosInstance.post(
        `${tenantVal}${PATIENT_FAMILY_MEMBER}`,
        {
          tenant: tenantVal,
          familyRelationType: relationship,
          mainPatientId: currentPatientId,
          relatedToPatientId: selectedPatient.id,
          canSeeRecords: false,
          id: initialPatientRelationship?.id,
        },
        { headers: { "Content-Type": "application/json" } }
      );
      toast.success(
        `Family relationship ${isEditing ? "updated" : "saved"} successfully`
      );
      refetchRelationships?.();
      closeModal();
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className={styles.form}>
      <div className={styles.field}>
        <label className={styles.label}>Search patient</label>
        <PatientAutocomplete
          value={selectedPatient}
          onChange={setSelectedPatient}
          placeholder="Search by name..."
        />
      </div>
      <div className={styles.field}>
        <label className={styles.label}>Relationship</label>
        <Select
          value={relationship}
          onChange={setRelationship}
          options={RELATIONSHIP_OPTIONS}
          placeholder="Select relationship"
          fullWidth
        />
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={closeModal}>
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          disabled={isSaving || !selectedPatient || !relationship}
        >
          {isEditing ? "Update relationship" : "Add relationship"}
        </Button>
      </DialogFooter>
    </div>
  );
};

export { PatientFamilySearch };
